import revalidate from '@/lib/revalidate';

export default async function advertisement(location, position = '', category = '') {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/advertisement?location=${location}&position=${position}&category=${category}`, {
    next: revalidate('REVALIDATE_ADVERTISEMENT')
  });

  const { data } = await res.json();

  return data;
}
